import React, {lazy, Suspense, useEffect, useRef, useState} from 'react';
import {BrowserRouter, Routes, Route, Link, useNavigate, Navigate, ScrollRestoration, useLocation} from 'react-router-dom'
import {Helmet, HelmetProvider} from 'react-helmet-async';
import './App.css';
import './styles/Common.css';
import 'animate.css/animate.min.css';

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import ResearchHighlights from "./components/ResearchHighlights";
import Services from "./components/Services";
// import Blog from "./components/Blog";
// import BlogPost from "./components/BlogPost";
// import Publications from "./components/Publications";
import News from "./components/News";
import Role from "./components/Role";
import People from "./components/People";
import Person from "./components/Person";
import Article from './components/Article';
import About from "./components/About";
import Bottombar from "./components/Footer";
import ScrollToTopOnMount from './hooks/ScrollToTopOnMount';
import ArticlesOuter from "./components/ArticlesOuter";
import Paper from "./components/Paper";

// const Chat = lazy(() => import("./components/Chat"));

const App = () => {

    const renderNavbarAndBottombar = () => {
            return (
                <>
                    {/*<ScrollRestoration/>*/}
                    <ScrollToTopOnMount/>
                    <Navbar />
                    <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/events" element={<News/>}/>
                        {/*<Route path="/research-highlights" element={<ResearchHighlights/>}/>*/}
                        {/*<Route path="/services" element={<Services/>}/>*/}
                        <Route path="/role" element={<Navigate to="/articles/the-role-and-mission-of-researchers-in-ai-development-and-governance" replace />} />
                        <Route path="/people" element={<People/>}/>
                        {/*<Route path="/~yizeng" element={<Person/>}/>*/}
                        <Route exact path="/articles/:slug" element={<Article />} />
                        {/*<Route path="/about" element={<About/>}/>*/}
                    </Routes>
                    </Suspense>
                    <Bottombar/>
                </>
            );

    };

    return (
        <HelmetProvider>
            <BrowserRouter>
                {renderNavbarAndBottombar()}
            </BrowserRouter>
        </HelmetProvider>
    );
};

export default App
